import styled from '@emotion/styled';
import React from 'react';
import notFound from '../../../../../../assets/flights-not-found.svg?reference';
import { Section } from '../../../../content-sections/ui/components/Section';
import { NoResultsMessage } from '../../../../shared/components';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { AvailabilityNoResultsBackLink as BackLink } from './AvailabilityNoResultsBackLink';

interface IAvailabilityNoResultsProps {
	previousUrl?: string;
}

export const AvailabilityNoResults = ({
	previousUrl,
}: IAvailabilityNoResultsProps) => {
	const { t } = useTranslation();

	return (
		<Section>
			<StyledNoResultsMessage
				title={t('parking_availability_no_products_error_title')}
				imageSource={notFound}
			>
				<p>{t('parking_availability_no_products_error_body')}</p>
				{previousUrl && <BackLink url={previousUrl} />}
			</StyledNoResultsMessage>
		</Section>
	);
};

const StyledNoResultsMessage = styled(NoResultsMessage)`
	padding-top: 0;
`;
